import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.team-workload.title',
		defaultMessage: 'Team workload',
		description: 'Title of the breakdown by team workload section.',
	},
	description: {
		id: 'contextual-summary.project-summary.team-workload.description',
		defaultMessage:
			'Monitor the capacity of your team. <link>Reassign issues to get the right balance</link>',
		description: 'Description of the breakdown by team workload section.',
	},
	emptyDescription: {
		id: 'contextual-summary.project-summary.team-workload.empty-description',
		defaultMessage: 'To monitor the capacity of your team, <link>create some issues</link>',
		description: "Description of the breakdown by team workload section when there's no data.",
	},
	unassigned: {
		id: 'contextual-summary.project-summary.team-workload.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Unassigned user description.',
	},
	typeColumn: {
		id: 'contextual-summary.project-summary.team-workload.type-column',
		defaultMessage: 'Assignee',
		description: 'Title for the type column of team workload section table.',
	},
	distributionColumn: {
		id: 'contextual-summary.project-summary.team-workload.distribution-column',
		defaultMessage: 'Work distribution',
		description: 'Title for the distribution column of team workload section table.',
	},
	counter: {
		id: 'contextual-summary.project-summary.team-workload.counter',
		defaultMessage: 'issues',
		description: 'Text for the tooltip hover counter for the work section percentage bar.',
	},
});
